import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import { FormRow } from '@zocdoc-frontend-common/styles-grid';
import Textbox from '@zocdoc-frontend-common/components-textbox';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';

const referringPhysicianHeader = 'Who is your referring physician?';
const referringPhysicianBody =
    'A referral may be required for your insurance to cover this visit.';

export class ReferringPhysicianView extends Component {
    static propTypes = {
        onReferringPhysicianEntered: PropTypes.func.isRequired,
        trackSelectReferringPhysician: PropTypes.func.isRequired,
    };

    renderMessage = () => {
        const { invalidMessage } = this.props;

        if (invalidMessage && invalidMessage.defaultMessage) {
            return invalidMessage.defaultMessage;
        }

        return invalidMessage;
    };

    render() {
        const {
            referringPhysician,
            onReferringPhysicianEntered,
            trimPhysicianValue,
            trackSelectReferringPhysician,
        } = this.props;

        return (
            <FormRow>
                <Header>{referringPhysicianHeader}</Header>
                <ReferringPhysician>
                    {referringPhysicianBody}
                </ReferringPhysician>
                <Textbox
                    className="exclude-from-playback"
                    invalidMessage={this.renderMessage()}
                    onBlur={trimPhysicianValue}
                    onChange={e => onReferringPhysicianEntered(e.target.value)}
                    onFocus={trackSelectReferringPhysician}
                    value={referringPhysician}
                />
            </FormRow>
        );
    }
}

const Header = styled.p`
    font: 15px/24px ${FontFamily.SharpSansSemibold};
`;

const ReferringPhysician = styled.p`
    font: 15px/24px ${FontFamily.SharpSansMedium};
    padding-top: 1px;
    padding-bottom: 3px;
`;
